import Vue from "vue";
import VueRouter from "vue-router";
import axios from "../plugins/axios";
import { i18n } from "../plugins/vue-i18n";

import Main from "../pages/client/Main.vue";
import { BoardRoutes } from "./board.router";
import { QuestionRoutes } from "./question.router";

Vue.use(VueRouter);

const routes = [
    ///////////////////////////////////////////////////////////////////////////////////////////////////////////////////
    // 사용자 페이지 라우트
    ///////////////////////////////////////////////////////////////////////////////////////////////////////////////////
    {
        // Main 페이지
        path: "/",
        component: Main,
    },
    {
        path: "/common/kcp/cert/request",
        component: () => import("../pages/common/kcp/KCPCertRequest.vue"),
        props: true,
    },
    {
        path: "/common/kcp/cert/response",
        component: () => import("../pages/common/kcp/KCPCertResponse.vue"),
        props: true,
    },
    {
        // 로그인
        path: "/login",
        component: () => import(/* webpackChunkName: "login" */ "../pages/client/login/main.vue"),
        props: true,
    },
    {
        // 비밀번호 찾기
        path: "/login/find-password",
        component: () => import(/* webpackChunkName: "login" */ "../pages/client/login/find-password.vue"),
        props: true,
    },
    {
        // 아이디 찾기
        path: "/login/find-id",
        component: () => import(/* webpackChunkName: "login" */ "../pages/client/login/find-id.vue"),
        props: true,
    },
    {
        // 회원가입
        path: "/join",
        component: () => import(/* webpackChunkName: "join" */ "../pages/client/join/main.vue"),
        props: true,
    },
    {
        // 회원가입 폼
        path: "/join/type",
        component: () => import(/* webpackChunkName: "join" */ "../pages/client/join/type.vue"),
        props: true,
    },
    {
        // 회원가입 폼
        path: "/join/form",
        component: () => import(/* webpackChunkName: "join" */ "../pages/client/join/form.vue"),
        props: true,
    },
    {
        // 회원가입 완료
        path: "/join/complete",
        component: () => import(/* webpackChunkName: "join" */ "../pages/client/join/complete.vue"),
        props: true,
    },
    {
        // 회원 정보 변경
        path: "/mypage/myinfo",
        component: () => import(/* webpackChunkName: "mypage" */ "../pages/client/mypage/myinfo.vue"),
        props: true,
    },
    {
        // 회원 탈퇴
        path: "/mypage/leave",
        component: () => import(/* webpackChunkName: "mypage" */ "../pages/client/mypage/leave.vue"),
        props: true,
    },
    {
        // 매칭상담회
        path: "/mypage/fairs",
        component: () => import(/* webpackChunkName: "fairs" */ "../pages/client/mypage/FairsListPage.vue"),
        props: true,
    },
    {
        // 매칭상담회
        path: "/mypage/fairs/:_fair",
        component: () => import(/* webpackChunkName: "fairs" */ "../pages/client/mypage/FairViewPage.vue"),
        props: true,
    },
    {
        // 상품관리
        path: "/mypage/products",
        component: () => import(/* webpackChunkName: "products" */ "../pages/client/mypage/ProductList.vue"),
        props: true,
    },
    {
        // 상품관리
        path: "/mypage/products/:_product",
        component: () => import(/* webpackChunkName: "products" */ "../pages/client/mypage/ProductInput.vue"),
        props: true,
    },
    {
        // 1:1 문의
        path: "/mypage/question",
        component: () => import(/* webpackChunkName: "question" */ "../pages/client/mypage/question.vue"),
        children: [...QuestionRoutes],
        props: true,
    },
    {
        // 회사소개
        path: "/about",
        component: () => import(/* webpackChunkName: "sub" */ "../pages/client/sub/about/AboutPage.vue"),
        props: true,
    },
    {
        // 매칭상담회 - 리스트
        path: "/fairs",
        component: () => import(/* webpackChunkName: "sub" */ "../pages/client/sub/fairs/FairsListPage.vue"),
        props: true,
    },
    {
        // 매칭상담회 - 뷰
        path: "/fairs/:_fair",
        component: () => import(/* webpackChunkName: "sub" */ "../pages/client/sub/fairs/FairsViewPage.vue"),
        props: true,
    },
    {
        // 매칭상담회 - 뷰
        path: "/fairs/view",
        component: () => import(/* webpackChunkName: "sub" */ "../pages/client/sub/fairs/FairsViewPage.vue"),
        props: true,
    },
    {
        // 작가소개
        path: "/board/author-intro",
        component: () => import(/* webpackChunkName: "board" */ "../pages/client/board/AuthorIntro.vue"),
        children: [...BoardRoutes],
        props: true,
    },
    {
        // 전시 및 행사
        path: "/board/travel",
        component: () => import(/* webpackChunkName: "board" */ "../pages/client/board/Travel.vue"),
        children: [...BoardRoutes],
        props: true,
    },
    {
        // 이벤트
        path: "/board/event",
        component: () => import(/* webpackChunkName: "board" */ "../pages/client/board/Event.vue"),
        children: [...BoardRoutes],
        props: true,
    },
    {
        // 문의 및 제휴
        path: "/form/inquiry-partner",
        component: () => import(/* webpackChunkName: "form" */ "../pages/client/form/InquiryPartner.vue"),
        props: true,
    },
    {
        // 공지사항
        path: "/center/notice",
        component: () => import(/* webpackChunkName: "center" */ "../pages/client/center/NoticePage.vue"),
        props: true,
    },
    {
        // 공지사항
        path: "/center/notice/:_notification",
        component: () => import(/* webpackChunkName: "center" */ "../pages/client/center/NoticePage.vue"),
        props: true,
    },
    {
        // 자료실
        path: "/center/reference",
        component: () => import(/* webpackChunkName: "center" */ "../pages/client/center/ReferencePage.vue"),
        props: true,
    },
    {
        // 자료실
        path: "/center/reference/:_reference",
        component: () => import(/* webpackChunkName: "center" */ "../pages/client/center/ReferencePage.vue"),
        props: true,
    },
    {
        // 자주묻는질문
        path: "/center/faqs",
        component: () => import(/* webpackChunkName: "center" */ "../pages/client/center/faq.vue"),
        props: true,
    },
    {
        // 개인정보처리방침
        path: "/privacy",
        component: () => import(/* webpackChunkName: "sub" */ "../pages/client/center/PrivacyPolicyPage.vue"),
        props: true,
    },

    {
        // 자문요청 목록
        path: "/counsel/:type",
        component: () => import(/* webpackChunkName: "counsel" */ "../pages/client/sub/counsel/CounselListPage.vue"),
        props: true,
    },
    {
        // 자문요청 생성
        path: "/counsel/:type/write",
        component: () => import(/* webpackChunkName: "counsel" */ "../pages/client/sub/counsel/CounselWritePage.vue"),
        props: true,
    },
    {
        // 자문요청 상세
        path: "/counsel/:type/:_counselRequest",
        component: () => import(/* webpackChunkName: "counsel" */ "../pages/client/sub/counsel/CounselViewPage.vue"),
        props: true,
    },
    {
        // 자문요청 수정
        path: "/counsel/:type/:_counselRequest/modify",
        component: () => import(/* webpackChunkName: "counsel" */ "../pages/client/sub/counsel/CounselModifyPage.vue"),
        props: true,
    },
    {
        // 전문가/전문기업 정보수정
        path: "/experts/modify",
        component: () => import(/* webpackChunkName: "counsel" */ "../pages/client/sub/experts/ExpertModifyPage.vue"),
        props: true,
    },
    {
        // 전문가/전문기업 목록
        path: "/experts/:userType",
        component: () => import(/* webpackChunkName: "counsel" */ "../pages/client/sub/experts/ExpertListPage.vue"),
        props: true,
    },
    {
        // 전문가/전문기업 상세
        path: "/experts/:userType/:_expert",
        component: () => import(/* webpackChunkName: "counsel" */ "../pages/client/sub/experts/ExpertViewPage.vue"),
        props: true,
    },
];

const router = new VueRouter({
    mode: "history",
    base: process.env.BASE_URL,
    routes,
});

router.beforeEach((to, from, next) => {
    axios.defaults.headers.common["Authorization"] = sessionStorage.getItem("accessToken") ? `Bearer ${sessionStorage.getItem("accessToken")}` : "";
    axios.defaults.headers.common["Accept-Language"] = i18n.locale;

    next();
});

export default router;
